import { render } from "./TheServices.vue?vue&type=template&id=30e7977a&scoped=true"
const script = {}

import "./TheServices.vue?vue&type=style&index=0&id=30e7977a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e7977a"]])

export default __exports__